export const currentFinancialYear = (date = new Date()) => {
  const year = date.getMonth() >= 3 ? date.getFullYear() : date.getFullYear() - 1;
  return `${year}-${String((year + 1) % 100).padStart(2, '0')}`;
};

export const emptyTaxDeclaration = (date = new Date()) => ({
  financial_year: currentFinancialYear(date),
  annual_turnover: '',
  employee_count: '0',
  classification_code: '',
  license_type: '',
  license_number: '',
  document_ids: '',
  evidence_note: '',
  notes: '',
  attestation: false,
});

export const declarationToForm = declaration => ({
  financial_year: declaration.financial_year || '',
  annual_turnover: declaration.annual_turnover ?? '',
  employee_count: String(declaration.employee_count ?? 0),
  classification_code: declaration.classification_code || '',
  license_type: declaration.license_type || '',
  license_number: declaration.license_number || '',
  document_ids: (declaration.evidence?.document_ids || []).join(', '),
  evidence_note: declaration.evidence?.note || '',
  notes: declaration.notes || '',
  attestation: Boolean(declaration.evidence?.attestation),
});

const cleanNullable = (value, max) => String(value || '').trim().slice(0, max) || null;

export const buildDeclarationPayload = (form, { selfService = false, includeFinancialYear = true } = {}) => {
  const financialYear = String(form.financial_year || '').trim();
  const match = financialYear.match(/^(\d{4})-(\d{2}|\d{4})$/);
  if (includeFinancialYear && (!match || Number(match[2]) !== (Number(match[1]) + 1) % (match[2].length === 2 ? 100 : 10000))) {
    throw new Error('आर्थिक वर्ष सलग असावे, उदा. २०२६-२७.');
  }
  const turnover = String(form.annual_turnover || '').trim();
  if (!/^(?:0|[1-9]\d{0,14})(?:\.\d{1,2})?$/.test(turnover)) {
    throw new Error('वार्षिक उलाढाल जास्तीत जास्त दोन दशांश स्थानांसह अचूक संख्येत भरा.');
  }
  const employeeCount = Number(form.employee_count);
  if (!Number.isSafeInteger(employeeCount) || employeeCount < 0 || employeeCount > 10000000) {
    throw new Error('कर्मचारी संख्या ० ते १,००,००,००० दरम्यान पूर्णांक असावी.');
  }
  const classificationCode = cleanNullable(form.classification_code, 80);
  if (!classificationCode) throw new Error('कर दर निवडण्यासाठी व्यवसाय वर्गीकरण संकेतांक आवश्यक आहे.');
  const licenseType = cleanNullable(form.license_type, 80);
  const licenseNumber = cleanNullable(form.license_number, 120);
  if (Boolean(licenseType) !== Boolean(licenseNumber)) {
    throw new Error('परवाना माहितीमध्ये प्रकार आणि क्रमांक दोन्ही भरा किंवा दोन्ही रिकामे ठेवा.');
  }
  const rawIds = String(form.document_ids || '').split(',').map(value => value.trim()).filter(Boolean);
  if (rawIds.some(value => !/^[1-9]\d*$/.test(value)) || rawIds.length > 20) {
    throw new Error('पुरावा कागदपत्र क्रमांक स्वल्पविरामाने वेगळे केलेले धन पूर्णांक असावेत (कमाल २०).');
  }
  if (selfService && !form.attestation) throw new Error('सादर करण्यापूर्वी घोषणेची पुष्टी करा.');
  return {
    ...(includeFinancialYear ? { financial_year: financialYear } : {}),
    annual_turnover: turnover,
    employee_count: employeeCount,
    classification_code: classificationCode,
    license_type: licenseType,
    license_number: licenseNumber,
    evidence: {
      document_ids: [...new Set(rawIds)],
      note: cleanNullable(form.evidence_note, 1000),
      ...(selfService ? { attestation: true } : {}),
    },
    notes: cleanNullable(form.notes, 2000),
  };
};

export const declarationStatusLabel = status => ({
  draft: 'मसुदा',
  submitted: 'सादर',
  approved: 'मंजूर',
  rejected: 'नाकारले',
  superseded: 'पूर्व आवृत्ती',
}[status] || status);
